import React, { useMemo } from 'react';

import {
  type QueryParams,
  invalidateInsightQueries,
  loadQuery,
} from 'common/actions/insightQueries';
import connect from 'common/core/connect';
export { getQueryKey } from 'common/actions/insightQueries';

export type { QueryParams } from 'common/actions/insightQueries';
export type { InsightQueriesState, InsightQueryState } from 'common/reducers/insightQueries';

type InsightQueriesContextValue = {
  loadQuery: (queryParams: QueryParams) => Promise<void>;
  invalidateInsightQueries: () => Promise<void>;
};

export const InsightQueriesContext = React.createContext<InsightQueriesContextValue>({
  loadQuery: () => Promise.resolve(),
  invalidateInsightQueries: () => Promise.resolve(),
});

type ConnectProps = {
  loadQuery: (queryParams: QueryParams) => Promise<void>;
  invalidateInsightQueries: () => Promise<void>;
};
type OwnProps = {
  children: React.ReactNode;
};
type Props = ConnectProps & OwnProps;

function InsightListContainer({ children, loadQuery, invalidateInsightQueries }: Props) {
  const contextValue = useMemo(
    () => ({ loadQuery, invalidateInsightQueries }),
    [loadQuery, invalidateInsightQueries],
  );
  return (
    <InsightQueriesContext.Provider value={contextValue}>{children}</InsightQueriesContext.Provider>
  );
}

export default connect(null, {
  loadQuery,
  invalidateInsightQueries,
})(InsightListContainer) as unknown as React.FC<OwnProps>;
